import { z } from 'zod';
import {
  BulletinRecipientTarget,
  BulletinDeliveryMethod,
  BulletinAttachmentMode,
} from 'further-types/lp/bulletin-update';
import { blockNoteEditor } from 'further-ui/validations';

const attachmentSchema = z.object({
  name: z.string(),
  path: z.string(),
  assignedInvestorIds: z.array(z.string()),
  previewUrl: z.string(),
  isUploading: z.boolean().optional(),
});

const baseSchema = z.object({
  id: z.string().optional(),
  recipientTarget: z.nativeEnum(BulletinRecipientTarget),
  investorIds: z.array(z.string()),
  deliveryMethod: z.nativeEnum(BulletinDeliveryMethod),
  subject: z.string(),
  title: z.string(),
  commentary: blockNoteEditor.blockNoteDocumentSchema,
  attachments: z.array(attachmentSchema),
  attachmentMode: z.nativeEnum(BulletinAttachmentMode),
  includeUkFinancialPromotionsNotice: z.boolean(),
  resendPublishedUpdates: z.boolean(),
});

const draftSchema = baseSchema.extend({
  useFullValidation: z.literal(false),
});

const fullValidationSchema = baseSchema.extend({
  useFullValidation: z.literal(true),
  subject: z.string().min(1, 'Subject line is required.'),
  title: z.string().min(1, 'Body title is required.'),
  commentary: blockNoteEditor.blockNoteDocumentSchema.min(
    1,
    'Body text is required.',
  ),
});

export const schema = z.discriminatedUnion('useFullValidation', [
  draftSchema,
  fullValidationSchema,
]);

export type BulletinUpdateFormValues = z.infer<typeof schema>;
